import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() btnCloseShow: boolean;
  @Input() btnCancelShow: boolean;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public showDisplay() {
    if(!this.btnCloseShow) {
      return 'none';
    }
    else {
      return '';
    }
  }
  public setTitleStyle() {
    if(!this.btnCloseShow) {
      return  {'justify-content' : 'center' };
    }
    return {};
  }
  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

}
